/**
 * Deterministic redaction bar width for an amount, in em.
 *
 * The width is a stable hash of the value itself, so the same amount always
 * produces the same bar (across pages and refreshes) while the exact amount
 * cannot be guessed from the bar length. Em units make the bar scale with the
 * surrounding font size.
 *
 * @param {number} value
 * @returns {number}
 */
export function redactedWidth(value) {
	const hash = stableHash(String(value));
	return Math.round((2.86 + (hash % 2.35)) * 100) / 100;
}

/**
 * Simple stable string hash (FNV-1a) returning an unsigned 32-bit integer.
 * @param {string} str
 * @returns {number}
 */
function stableHash(str) {
	let hash = 0x811c9dc5;
	for (let i = 0; i < str.length; i++) {
		hash ^= str.charCodeAt(i);
		hash = Math.imul(hash, 0x01000193);
	}
	return hash >>> 0;
}
